import {GetBannerResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/banner/service.types';

export const ospBannerMock: GetBannerResponse = {
  banner: {
    variant: {
      $case: 'highlightBanner',
      highlightBanner: {
        headline: 'Thanks for your order',
        subline: 'Get -10% on your next purchase with code THANKS',
        colors: {
          foregroundColor: {hex: '#FFFFFF'},
          backgroundColor: {hex: '#3B0764'},
        },
        gradientColors: [
          {red: 124, green: 58, blue: 237},
          {red: 124, green: 58, blue: 237, alpha: 0},
        ],
        media: {
          backgroundColor: '#3B0764',
        },
        countdown: {
          endsAt: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000),
        },
        infoIcon: {
          headline: 'About this offer',
          content: {
            text: 'Code valid for 48 hours. Cannot be combined with other promotions.',
          },
        },
        productImages: [],
        isAd: false,
        target: {url: '/sale', external: false},
        tracker: {
          $case: 'promotionTracker',
          promotionTracker: {
            promotionId: 'mock-osp-banner',
            promotionName: 'Mock OSP Banner',
            creativeName: 'osp',
            creativeSlot: 'order-success-page',
          },
        },
      },
    },
  },
};
